import { Button } from '@thanx/uikit/button'
import PageHeader from 'components/PageHeader'
import TabItem from 'components/Tabs/TabItem'
import TabNav from 'components/Tabs/TabNav'
import TabPane from 'components/Tabs/TabPane'
import { TooltipWhenDisabled } from 'components/TooltipWhenDisabled'
import { useIsRbacAdmin } from 'hooks/useIsRbacAdmin'
import { buildTranslate } from 'locales'
import { useCallback } from 'react'
import Tab from 'react-bootstrap-five/Tab'
import Helmet from 'react-helmet'
import { useDispatch } from 'react-redux'
import { RouteComponentProps } from 'react-router-dom'
import { push, replace } from 'react-router-redux'
import { RolesTab } from './RolesTab'
import { UsersTab } from './UsersTab'

const t = buildTranslate('dashboard_access')

type TabKey = 'users' | 'roles'

const VALID_TABS: TabKey[] = ['users', 'roles']

export const DashboardAccess = ({ location }: RouteComponentProps) => {
  const dispatch = useDispatch()
  const isAdmin = useIsRbacAdmin()
  const tabParam = new URLSearchParams(location.search).get('tab')
  const activeTab: TabKey =
    tabParam && VALID_TABS.includes(tabParam as TabKey)
      ? (tabParam as TabKey)
      : 'roles'

  const handleSelect = useCallback(
    (tab: string | null) => {
      if (tab && tab !== activeTab) {
        dispatch(replace(`/merchant_users?tab=${tab}`))
      }
    },
    [dispatch, activeTab]
  )

  const showInviteButton = activeTab === 'users'

  return (
    <PageHeader
      title={t('header.title')}
      buttonText={
        showInviteButton && isAdmin ? t('header.invite_button') : undefined
      }
      buttonAction={
        showInviteButton && isAdmin
          ? () => dispatch(push('/merchant_users/new'))
          : undefined
      }
      menu={
        showInviteButton && !isAdmin ? (
          <TooltipWhenDisabled disabled tooltip={t('header.requires_admin')}>
            <Button disabled>{t('header.invite_button')}</Button>
          </TooltipWhenDisabled>
        ) : undefined
      }
    >
      <Helmet>
        <title>{t('header.title')}</title>
      </Helmet>
      <Tab.Container
        activeKey={activeTab}
        transition={false}
        onSelect={handleSelect}
      >
        <TabNav>
          <TabItem state="users" title={t('tabs.users')} />
          <TabItem state="roles" title={t('tabs.roles')} />
        </TabNav>
        <Tab.Content>
          <TabPane state="users">
            <UsersTab />
          </TabPane>
          <TabPane state="roles">
            <RolesTab />
          </TabPane>
        </Tab.Content>
      </Tab.Container>
    </PageHeader>
  )
}
